var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBicycle = function SvgIconBicycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.008 5.502A1 1 0 0 1 13.875 5H18a2.5 2.5 0 0 1 2.5 2.5 1 1 0 1 1-2 0A.5.5 0 0 0 18 7h-2.384l.836 1.433a1 1 0 0 1 .076.13l1.12 1.921a4.75 4.75 0 1 1-1.727 1.009L15.052 10h-3.687l1.528 2.621a1 1 0 1 1-1.728 1.008L9.5 10.773l-.958 1.208a4.75 4.75 0 1 1-1.567-1.243l1.443-1.82L7.3 7H4.875a1 1 0 0 1 0-2h3a1 1 0 0 1 .864.496L10.199 8h3.685l-.873-1.496a1 1 0 0 1-.003-1.002M4.09 14.379l1.591-2.009a2.75 2.75 0 1 0 1.568 1.242l-1.591 2.009a1 1 0 1 1-1.568-1.242m14.17 1.125-1.29-2.213a2.75 2.75 0 1 0 1.727-1.008l1.29 2.213a1 1 0 0 1-1.727 1.008",
    clipRule: "evenodd"
  })));
};
export default SvgIconBicycle;